export default {"src":"/_next/static/media/heartIconFilled.49bf1a90.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};